import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



export default function Step8() {

  return (
    <>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsurancenameinsured" fullWidth label="NAMED INSURED " />
        </Grid>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranceagent" fullWidth label="Agent" />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranceaddress" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="defendantinsurancecity"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantinsurancezip" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantinsurancephone" fullWidth label="Phone" />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsurancadjuster" fullWidth label="ADJUSTER" />
        </Grid>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranc-coverageconfirmed" fullWidth label="Coverage confirmed " />
        </Grid>

      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsurancpolicyno" fullWidth label="POLICY NO" />
        </Grid>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranc-company" fullWidth label="COMPANY" />
        </Grid>

      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranceaddress1" fullWidth label="Address" />
        </Grid>
        <Grid item  xs={12}  sm={2}>
            <TextField
            id="defendantinsurancecity1"
            fullWidth
            label="City"
            />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantinsurancezip1" fullWidth label="Zip" />
        </Grid>
        <Grid item  xs={12} sm={2}>
            <TextField id="defendantinsurancephone1" fullWidth label="Phone" />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsuranc-claimno" fullWidth label="CLAIM NO" />
        </Grid>
        <Grid item  xs={12} sm={6}>
            <TextField id="defendantinsurancby" fullWidth label="By" />
        </Grid>

      </Grid>




      

      


</>
    
  );

}
